import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-24f042ae")

_pushScopeId("data-v-24f042ae")
const _hoisted_1 = { class: "screen-settings" }
const _hoisted_2 = { class: "screen-wrap" }
const _hoisted_3 = { class: "screen" }
const _hoisted_4 = {
  key: 0,
  class: "video-container videoSlot"
}
const _hoisted_5 = { class: "footer" }
const _hoisted_6 = { class: "setting-wrap" }
const _hoisted_7 = { class: "description-wrap" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "description" }
const _hoisted_10 = { class: "start-time" }
const _hoisted_11 = { class: "button-wrap" }
const _hoisted_12 = {
  key: 0,
  class: "is-end"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("div", null, "Конференция завершена", -1)
const _hoisted_14 = {
  key: 1,
  class: "is-end"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Info = _resolveComponent("Info")
  const _component_userVideoMock = _resolveComponent("userVideoMock")
  const _component_SpeakerName = _resolveComponent("SpeakerName")
  const _component_ButtonPanel = _resolveComponent("ButtonPanel")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_Info, {
          class: "info-screen",
          isShow: !!_ctx.deviceError,
          errorInfo: _ctx.deviceError
        }, null, 8, ["isShow", "errorInfo"]),
        (!_ctx.deviceError)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode("video", {
                class: "video",
                style: {display: _ctx.devices.videoEnabled ? 'block' : 'none'},
                ref: "mirrorVideo",
                autoplay: "true",
                playsinline: ""
              }, null, 4),
              (!_ctx.devices.videoEnabled)
                ? (_openBlock(), _createBlock(_component_userVideoMock, {
                    key: 0,
                    class: "mock",
                    name: _ctx.auth.displayName
                  }, null, 8, ["name"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_SpeakerName, {
          class: "name",
          name: _ctx.auth.displayName,
          isStartSettings: true
        }, null, 8, ["name"])
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_ButtonPanel, { deviceError: _ctx.deviceError }, null, 8, ["deviceError"])
      ]),
      _createVNode("div", _hoisted_7, [
        (_ctx.conferenceInfo)
          ? (_openBlock(), _createBlock("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _createVNode("div", null, _toDisplayString(_ctx.conferenceInfo.description), 1)
              ]),
              _createVNode("div", _hoisted_10, [
                _createVNode("div", null, _toDisplayString(_ctx.conferenceInfo.start), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_11, [
        (_ctx.isEnded)
          ? (_openBlock(), _createBlock("div", _hoisted_12, [
              _hoisted_13
            ]))
          : (_ctx.errorInfo)
            ? (_openBlock(), _createBlock("div", _hoisted_14, [
                _createVNode("div", null, _toDisplayString(_ctx.errorInfo), 1)
              ]))
            : (_ctx.leftTimeInfo)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 2,
                  class: "button-setting join-button",
                  mode: "primary",
                  disabled: _ctx.isJoinDisable,
                  onClick: _ctx.clickJoin
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.leftTimeInfo), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"]))
              : (_openBlock(), _createBlock(_component_Button, {
                  key: 3,
                  class: "button-setting join-button",
                  mode: "primary",
                  disabled: _ctx.isJoinDisable,
                  onClick: _ctx.clickJoin
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('join.btn')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"]))
      ])
    ])
  ]))
})